import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import log from '~/helpers/log';

export default function useAddNewTrack() {
  const deviceManager = useSelector(
    state => state.system && state.system.deviceManager
  );
  const deviceManagerMemo = useMemo(() => deviceManager, [deviceManager]);
  const addNewMicrophone = useCallback(
    async sessionActive => {
      try {
        if (sessionActive && sessionActive.sessionDescriptionHandler) {
          const pc = sessionActive.sessionDescriptionHandler.peerConnection;
          const constraints = {
            audio: {
              deviceId: { exact: deviceManagerMemo.audio.microphone.deviceId },
            },
            video: false,
          };
          const stream = await navigator.mediaDevices.getUserMedia(constraints);
          // Get mediaStreamTrack
          const track = stream.getTracks()[0];

          // This add a new track to RTCRtpSender
          pc.getSenders().forEach(sender => {
            // If the previous mic was muted then keep it muted for the other microphones while in the call.
            if (!sender.track.enabled) track.enabled = false;
            sender.replaceTrack(track);
          });
        }
      } catch (err) {
        switch (err.name) {
          case 'NotReadableError':
            log.error(
              "NUACOM-LOG: Passed constraints don't match any audio device.",
              err
            );
            break;
          case 'OverconstrainedError':
            log.error('NUACOM-LOG:  Audio is already in use.', err);
            break;
          default:
            log.error(
              'NUACOM-LOG:  Exception happened in useAddNewTrack().',
              err
            );
            break;
        }
      }
    },
    [deviceManagerMemo]
  );

  return addNewMicrophone;
}
